import React, { useState, useRef } from "react";
import {
    FaWhatsapp,
    FaTimes,
    FaPaperPlane
} from "react-icons/fa";
import "./WhatsAppBot.css";

const API_URL = "https://api.sg1.co.il";
const WHATSAPP_LOG_API = `${API_URL}/api/whatsapp-click`;

const BUSINESS_WHATSAPP = "972506978865";
const QUESTIONS = [
    "שלום 👋 אני הנציג הדיגיטלי של SG1 ניקיון ואחזקה, באיזה שירות אתה מעוניין?",
    "מה סוג הנכס?",
    "באיזו עיר נמצא הנכס?",
    "מה השם שלך?",
    "מה מספר הטלפון שלך?"
];

const OPTIONS = [
    [
        "ניקיון משרדים",
        "ניקיון בניינים",
        "ניקיון אחרי שיפוץ",
        "פוליש וקרצוף רצפות",
        "ניקיון שטחים ציבוריים",
        "אחזקה שוטפת למבנים",
        "אחר"
    ],
    [
        "משרד",
        "בניין משרדים",
        "מרכז מסחרי",
        "מפעל",
        "מוסד ציבורי",
        "בית פרטי",
        "אחר"
    ]
];

export default function WhatsAppBot() {
    const [open, setOpen] = useState(false);
    const [step, setStep] = useState(0);
    const [input, setInput] = useState("");

    const [answers, setAnswers] = useState({
        service: "",
        propertyType: "",
        city: "",
        customerName: "",
        customerPhone: ""
    });

    const [messages, setMessages] = useState([
        { type: "bot", text: QUESTIONS[0] }
    ]);

    const [selectedOption, setSelectedOption] = useState(false);
    const [finished, setFinished] = useState(false);
    const [sending, setSending] = useState(false);

    const sendingRef = useRef(false);

    function addMessage(type, text) {
        setMessages(prev => [
            ...prev,
            { type, text }
        ]);
    }

    function nextQuestion(nextStep) {
        setStep(nextStep);

        if (nextStep < QUESTIONS.length) {
            addMessage("bot", QUESTIONS[nextStep]);
        }
    }

    function selectOption(option) {
        if (selectedOption) return;

        setSelectedOption(true);

        const field =
            step === 0 ? "service" : "propertyType";

        setAnswers(prev => ({
            ...prev,
            [field]: option
        }));

        addMessage("user", option);

        setTimeout(() => {
            setSelectedOption(false);
            nextQuestion(step + 1);
        }, 400);
    }

    function sendMessage() {
        const value = input.trim();

        if (!value || OPTIONS[step] || sending) return;

        if (step === 2) {
            if (!/^[א-תa-zA-Z\s-]{2,}$/.test(value)) {
                addMessage("bot", "❌ נא להזין שם עיר תקין");
                return;
            }
        }

        if (step === 3) {
            if (!/^[א-תa-zA-Z\s'-]{2,}$/.test(value)) {
                addMessage("bot", "❌ נא להזין שם תקין");
                return;
            }
        }

        if (step === 4) {
            const phone = value.replace(/\D/g, "");

            if (!/^05\d{8}$/.test(phone)) {
                addMessage(
                    "bot",
                    "❌ נא להזין מספר טלפון תקין\nלדוגמה: 0501234567"
                );
                return;
            }

            setAnswers(prev => ({
                ...prev,
                customerPhone: phone
            }));

            addMessage("user", phone);
            setInput("");
            setStep(5);

            setTimeout(() => {
                addMessage(
                    "bot",
                    "🎉 מעולה! כל הפרטים התקבלו.\nלחץ על הכפתור לפתיחת WhatsApp שליחת הפנייה."
                );

                setFinished(true);
            }, 400);

            return;
        }

        const fieldMap = {
            2: "city",
            3: "customerName"
        };

        const field = fieldMap[step];

        setAnswers(prev => ({
            ...prev,
            [field]: value
        }));

        addMessage("user", value);
        setInput("");

        setTimeout(() => {
            nextQuestion(step + 1);
        }, 400);
    }

    function createWhatsappMessage(lead) {
        return [
            "🏢 פנייה חדשה מהאתר - SG1 ניקיון ואחזקה",
            "",
            "שירות מבוקש: " + lead.service,
            "סוג נכס: " + lead.propertyType,
            "עיר: " + lead.city,
            "שם לקוח: " + lead.customerName,
            "טלפון לקוח: " + lead.customerPhone
        ].join("\n");
    }

    async function sendWhatsapp() {
        if (sendingRef.current) return;

        sendingRef.current = true;
        setSending(true);

        const lead = { ...answers };

        const whatsappText = createWhatsappMessage(lead);

        const whatsappUrl =
            `https://api.whatsapp.com/send?phone=${BUSINESS_WHATSAPP}&text=${encodeURIComponent(
                whatsappText
            )}`;

        // פתיחת WhatsApp מתוך לחיצת המשתמש
        const whatsappWindow = window.open(
            whatsappUrl,
            "_blank"
        );

        // גיבוי אם הדפדפן חסם את החלון
        if (!whatsappWindow) {
            window.location.href = whatsappUrl;
        } else {
            whatsappWindow.opener = null;
        }

        try {
            const response = await fetch(
                WHATSAPP_LOG_API,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(lead),
                    keepalive: true
                }
            );

            const result = await response.json();

            if (!response.ok || !result.success) {
                throw new Error(
                    result.message || "Lead save failed"
                );
            }

            addMessage(
                "bot",
                "✅ הפרטים נשמרו בהצלחה! תודה רבה, ניצור איתך קשר בהקדם."
            );

            setFinished(false);

            setTimeout(resetChat, 30000);

        } catch (error) {
            console.error(
                "SG1 WhatsApp lead error:",
                error
            );

            addMessage(
                "bot",
                "⚠️ לא הצלחנו לשמור את הפרטים במערכת. אפשר לפנות אלינו ישירות בוואטסאפ."
            );

            sendingRef.current = false;
            setSending(false);
        }
    }

    function resetChat() {
        setStep(0);
        setInput("");

        setAnswers({
            service: "",
            propertyType: "",
            city: "",
            customerName: "",
            customerPhone: ""
        });

        setMessages([
            { type: "bot", text: QUESTIONS[0] }
        ]);

        setSelectedOption(false);
        setFinished(false);
        setSending(false);
        sendingRef.current = false;
    }

    return (
        <>
            <button
                className="wa-button"
                onClick={() => setOpen(true)}
                aria-label="פתיחת צ'אט WhatsApp"
            >
                <FaWhatsapp />
            </button>

            {open && (
                <div className="chat">
                    <div className="header2">
                        <div className="logoArea">
                            <img
                                src="/logo192.jpeg"
                                alt="חברת ניקיון ואחזקות"
                            />

                            <span>
                                חברת ניקיון ואחזקות
                            </span>
                        </div>

                        <button
                            onClick={() => setOpen(false)}
                            aria-label="סגירת צ'אט"
                        >
                            <FaTimes />
                        </button>
                    </div>

                    <div className="messages">
                        {messages.map((msg, i) => (
                            <div
                                key={i}
                                className={
                                    msg.type === "bot"
                                        ? "bot"
                                        : "user"
                                }
                            >
                                {msg.text}
                            </div>
                        ))}

                        {OPTIONS[step] && !selectedOption && (
                            <div className="options">
                                {OPTIONS[step].map((item, i) => (
                                    <button
                                        key={i}
                                        onClick={() =>
                                            selectOption(item)
                                        }
                                    >
                                        ◯ {item}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>

                    {!OPTIONS[step] &&
                        !finished &&
                        step < QUESTIONS.length && (
                            <div className="inputBox">
                                <input
                                    value={input}
                                    onChange={e =>
                                        setInput(e.target.value)
                                    }
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            sendMessage();
                                        }
                                    }}
                                    placeholder="כתוב הודעה..."
                                    disabled={sending}
                                />

                                <button
                                    onClick={sendMessage}
                                    disabled={sending}
                                    aria-label="שליחת תשובה"
                                >
                                    <FaPaperPlane />
                                </button>
                            </div>
                        )}

                    {finished && (
                        <button
                            className="sendWA"
                            onClick={sendWhatsapp}
                            disabled={sending}
                        >
                            <FaWhatsapp />
                            {sending
                                ? "שולח..."
                                : "פתיחת WhatsApp ושליחת פנייה"}
                        </button>
                    )}
                </div>
            )}
        </>
    );
}
